import {InjectionToken} from "@angular/core";
import {HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";

/**
 * Wie die DuckDB-Repositories an den Export kommen. Ohne Eintrag fragen sie per HTTP den lokalen Server des
 * Electron-Viewers; der Browser-Viewer traegt hier DuckDB-Wasm ein, das die Datei im Browser liest.
 */
export interface DuckDbTransport {

  query(sql: string): Observable<any[]>;

  loadMedia(mediaId: string): Observable<HttpResponse<Blob>>;
}

export const DUCKDB_TRANSPORT: InjectionToken<DuckDbTransport> = new InjectionToken<DuckDbTransport>('DuckDbTransport');
